import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import CTABanner from "./components/CTABanner";
import IndustriesSection from "./components/IndustriesSection";
import MetricsSection from "./components/MetricsSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ProcessSection from "./components/ProcessSection";
import CaseStudiesSection from "./components/CaseStudiesSection";
import CertificationsSection from "./components/CertificationsSection";
import EnterpriseTrustSection from "./components/EnterpriseTrustSection";
import JobSeekersSection from "./components/JobSeekersSection";
import BankingSection from "./components/BankingSection";
import PartnersSection from "./components/PartnersSection";
import TechnologiesSection from "./components/TechnologiesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AwardsSection from "./components/AwardsSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-500 focus:text-background-50 focus:rounded-md focus:font-semibold focus:text-sm"
      >
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <TrustBar />
        <AboutSection />
        <ServicesSection />
        <CTABanner />
        <IndustriesSection />
        <MetricsSection />
        <WhyChooseSection />
        <ProcessSection />
        <CaseStudiesSection />
        <CertificationsSection />
        <EnterpriseTrustSection />
        <JobSeekersSection />
        <BankingSection />
        <PartnersSection />
        <TechnologiesSection />
        <TestimonialsSection />
        <AwardsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}